import { AuxButton } from "@blk/aladdin-react-components-es";
import { AuxButtonTypeEnum } from "@blk/aladdin-web-components";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import "components/pages/portfolio/insDeletePortfolioAction.scss";
import { CloseDialogButton } from "./closeButtonDialog";
import { CustomFooter } from "./customFooter";
import { useDashboardFullPathInformations } from "components/workspaces/hooks/use-current-dashboard";
import { cancelEdit } from "components/workspaces/insWorkspaceEditModeActionBar";
import { language } from "language/default";
import { closeDialog } from "store/messages-dialog";
export const InsCancelEditDialogAction = () => {
    const removedSections = useSelector((state) => state.designer.present.removedSections) || [];
    const firstPast = useSelector((state) => state.designer.past[0]), { pathInformations, selectedSection } = useDashboardFullPathInformations();
    const dispatch = useDispatch();
    return React.createElement(CustomFooter, null,
        React.createElement(AuxButton, { label: language.en.common.ok, key: "main-ok-button", type: AuxButtonTypeEnum.PRIMARY, onClick: () => {
                cancelEdit(removedSections, selectedSection, firstPast, pathInformations, dispatch);
                dispatch(closeDialog());
            } }),
        React.createElement(CloseDialogButton, null));
};
